"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CharacterCount_1 = __importDefault(require("./CharacterCount"));
exports.default = CharacterCount_1.default;
